/*
 * @Description: 更换商品
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'

import goodsProject from './components/goodsProject.vue'
import InfiniteLoading from 'vue-infinite-loading'
import Sku from '@/components/sku/sku.tpl.vue'
import { wxShare } from '@/utils/wxsdk'
// import infiniteScroll from 'vue-infinite-scroll'

import {
    getAdviceGoodsData,
    getAdviceGoodsList,
    getGoodsSkuInfo
} from '@/models/advice.js'

export default {
    name: viewName.changeGoods,
    // directives: { infiniteScroll },
    inject: ['showLoading', 'hideLoading'],
    props: {
    },
    components: {
        goodsProject,
        Sku,
        InfiniteLoading
    },
    data () {
        return {
            nowItem: {}, // 当前点击的商品 对象
            nowItemIndex: '', // 当前点击的商品索引
            skus: {}, // 切换规格使用：规格参数
            baseItemCode: '',
            sstore_id: '',
            maintain_cate_id: '',
            goodsType: '', // 添加商品还是更换商品 add change
            goods_id: '', // 当前选择更改的商品id
            list: [], // 当前页面的接口数据
            pagesize: 20,
            page: 1,
            selectedList: [], // 已选列表
            filterObj: [
                {
                    name: '厂商直供',
                    value: 1,
                    isSelect: false
                },
                {
                    name: '现货',
                    value: 2,
                    isSelect: false
                },
                {
                    name: '包安装',
                    value: 3,
                    isSelect: false
                },
            ]
        }
    },
    computed: {
        ...mapState({
            adviceList: ({ advice }) => advice.list, // 保养项目列表
            vehicle_id: ({ advice }) => advice.vehicle_id, // 机型id
            selectData: ({ advice }) => advice.selectData.goodsList, // 已选数据
            isWeixin: ({ appInfo }) => appInfo.isWeixin, // 是否是微信环境
            maintain_id: ({ advice }) => advice.maintain_id, // 保养id
        }),
    },
    created () {
        /* 获取地址参数 */
        const { sstore_id, maintain_cate_id, baseItemCode, goodsType, goods_id } = this.$route.query
        this.baseItemCode = baseItemCode
        this.sstore_id = sstore_id
        this.maintain_cate_id = maintain_cate_id
        this.goodsType = goodsType
        this.goods_id = Number(goods_id)

        this.$emit('setHeader', {
            title: goodsType === 'changeGoods' ? '更换商品' : '添加商品',
            showHeader: true,
            showLeft: true,
        })

        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })

        console.log('changegoods creat')
    },
    activated () {
    },
    mounted () {
        /* 微信分享 */
        this.configWxShare()

        /* 获取已选数据 */
        this.getSelectedList()

        console.log('changegoods mounted')
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'updateAdviceList'
        ]),
        /**
         * 配置微信分享
         */
        configWxShare () {
            if (this.isWeixin) {
                const ADVICE_HREF = sessionStorage.getItem('ADVICE_HREF')
                wxShare({
                    link: ADVICE_HREF,
                    title: '为您推荐了一份爱车保养方案',
                    imgUrl: 'https://image.carisok.com/images/mall.png',
                    desc: '海量优质车品，智能匹配车型，车辆保养更轻松'
                })
            }
        },
        /**
         * 关闭弹窗
         */
        onClose () {
            /* 把勾选去掉 */
            this.list[this.nowItemIndex].is_selectd = 0
        },
        /**
         * 点击商品，跳转商品详情
         */
        toGoodsDetail (obj) {
            console.log(obj)
            /* 跳转服务详情 */
            this.$router.push({
                path: '/goodsDetail',
                query: {
                    sstore_id: this.sstore_id,
                    spu_id: obj.spu_id,
                    goods_id: obj.id,
                    goods_type: obj.goods_type,
                    selected_num: obj.selected_num,
                    maintain_id: this.maintain_id,
                    source: this.goodsType,
                    now_id: this.selectedList.length > 0 ? this.selectedList[0].id : null, // 当前要更换的商品id
                    baseItemCode: this.baseItemCode,
                }
            })
        },
        /**
         * 切换规格
         */
        async onGoodsSkuChange (obj) {
            /* 显示loading */
            this.showLoading()
            /* 请求接口 获取规格数据 */
            const skus = await getGoodsSkuInfo({
                sstore_id: this.sstore_id, // 门店id
                goods_type: obj.goods_type, // 商品类型（proprietary:自营，agent：代理）
                goods_id: obj.id, // 商品规格id
                spu_id: obj.spu_id, // 商品id
                vehicle_id: this.vehicle_id, // 车型id
            })
            /* 隐藏loading */
            this.hideLoading()
            this.skus = {
                ...skus
            }
            this.$refs.sku.open()
        },
        /**
         * 打开规格切换弹窗
         */
        onShowSkuPopup (data) {
            this.skus = {
                ...data
            }
            this.$refs.sku.open()
        },
        /**
         * 子组件 确定 按钮 回调
         * 商品切换规格
         */
        async onChangeSku (obj) {
            /* 请求数据：通过规格id查询 兼容保养建议列表的数据 */
            const data = await getAdviceGoodsData({
                sstore_id: this.sstore_id,
                goods_type: obj.selectedSkuComb.goods_type,
                goods_id: obj.selectedSkuComb.goods_id, // 商品规格id
                spu_id: obj.selectedSkuComb.spu_id, // 商品id
                vehicle_id: this.vehicle_id // 车型id
            })
            /* 获取新的当前选中的数据（已选规格） */
            this.nowItem = Object.assign(data, {
                is_selectd: 1,
            })

            /* 更新 vuex的数据 */
            this.upData(obj)
        },
        /*
         * 获取已选数据
         */
        getSelectedList () {
            const list = JSON.parse(JSON.stringify(this.adviceList))
            let selectedList = list.find((item) => {
                console.log(item.baseItemCode)
                return item.baseItemCode === this.baseItemCode
            })
            /* 判断如果是更换商品，只显示配对的商品，只显示一个 */
            if (this.goodsType === 'changeGoods') {
                const selectedGoodsList = selectedList.goods.filter((item) => {
                    return item.id === this.goods_id
                })
                selectedList.goods = selectedGoodsList
            }
            this.selectedList = selectedList.goods
        },
        /**
         * 改变筛选条件列表
         */
        async onChangeListFilter (index) {
            this.filterObj[index].isSelect = !this.filterObj[index].isSelect
            this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
            /* 请求数据 */
            this.page = 1
            this.list = []
            // await this.getData() // 这里不能请求数据 下面的回调会自动触发
        },
        /*
         * 获取过滤条件
         */
        getFilterInfo () {
            const arr = this.filterObj.filter((item) => {
                return item.isSelect === true
            })
            const result = arr.map((item) => {
                return item.value
            })
            return result.join(',')
        },
        /**
         * 无限滚动 回调，页面进入默认触发
         */
        infinite () {
            this.getData()
        },
        /**
         * 获取数据
         */
        async getData () {
            const params = {
                /* 筛选条件 */
                filter: this.getFilterInfo(),
                /* 保养分类id */
                maintain_cate_id: this.maintain_cate_id,
                /* 门店id */
                sstore_id: this.sstore_id,
                /* 车型id */
                vehicle_id: this.vehicle_id,
                pagesize: this.pagesize,
                page: this.page
            }
            const res = await getAdviceGoodsList(params)
            /* 返回数据需要显示 是否 勾选复选框 ，前端控制 */
            const newArr = res.list.map((item) => {
                item.is_selectd = 0
                item.selected_num = 1
                return item
            })
            this.list = this.list.concat(newArr)
            if (res.total_page <= this.page) {
                // this.page = 1
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
            } else {
                this.page++
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
            }
        },
        /**
         * 更新数据
         * @param{obj} 选择规格后的回调参数
         */
        upData (obj) {
            console.log(obj)
            var list = JSON.parse(JSON.stringify(this.adviceList))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                if (item.baseItemCode === this.baseItemCode) {
                    if (this.goodsType === 'changeGoods') {
                        /* 当前选中要替换的子节点id */
                        const selectedChangeId = this.selectedList[0].id
                        for (let j = 0; j < item['goods'].length; j++) {
                            let childrenItem = item['goods'][j]
                            if (childrenItem.id === selectedChangeId) {
                                /* 核心: 替换成选中的 */
                                list[i]['goods'][j] = Object.assign(this.nowItem, {
                                    selected_num: obj.selectedNum,
                                    baseItemCode: item.baseItemCode
                                })
                            }
                        }
                        // 合并商品
                        let record = { goods: new Map() }
                        for (let j = 0; j < item['goods'].length; j++) {
                            let good = item['goods'][j]
                            let predata = record['goods'].get(good.id)
                            if (predata) {
                                let newObj = { ...predata }
                                newObj['selected_num'] += good['selected_num']
                                /* 判断如果大于库存要使用库存 */
                                let selected_num = newObj.stock_num <= newObj.selected_num
                                    ? newObj.stock_num
                                    : newObj.selected_num
                                newObj['selected_num'] = selected_num

                                record['goods'].set(good.id, newObj)
                            } else {
                                record['goods'].set(good.id, good)
                            }
                        }
                        item['goods'] = [...record.goods.values()]
                    } else {
                        /* 判断是否有相同的商品id, 如果有就合并数量 */
                        let isEqually = false
                        item['goods'].forEach((item, j) => {
                            if (Number(item.id) === this.nowItem.id) {
                                isEqually = true
                                list[i]['goods'][j].selected_num = list[i]['goods'][j].selected_num + obj.selectedNum
                                /* 判断如果大于库存要使用库存 */
                                let selected_num = list[i]['goods'][j].stock_num <= list[i]['goods'][j].selected_num
                                    ? list[i]['goods'][j].stock_num
                                    : list[i]['goods'][j].selected_num
                                list[i]['goods'][j].selected_num = selected_num
                            }
                        })
                        /* 如果没有相同的商品id，就添加新商品 */
                        if (!isEqually) {
                            /* push一个新的子节点 */
                            item['goods'].push(Object.assign(this.nowItem, {
                                selected_num: obj.selectedNum,
                                baseItemCode: item.baseItemCode
                            }))
                        }
                    }
                }
            }
            /* 更新vuex */
            this.updateAdviceList(list)
            this.$refs.sku.close()
            /* 返回上一页 */
            this.$router.go(-1)
        },
        /**
         * 列表选择触发
         */
        checkboxChildrenChange (obj) {
            /* 当前选中的item */
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].id === obj.childrenId) {
                    this.nowItem = this.list[i]
                    this.nowItemIndex = i
                    break
                }
            }
            /* 获取需要切换规格前的数据 并显示弹窗 */
            this.onGoodsSkuChange(this.nowItem)
        },
    },
}
